import { createApi } from '@reduxjs/toolkit/query/react';
import { format } from 'url';

import { TagTypesEnum } from '@enum/tag-types.enum';
import { AddCredentialRequestInterface, CredentialInterface } from '@interface/credential/credential.interface';
import { PaginationRequestInterface, ResponseDataInterface } from '@interface/logs/response-data.interface';
import { portalQueryAuth } from '@util/api/portal-query-auth';
import { queryBuilder } from '@util/api/query-builder';

export const credentialApi = createApi({
  reducerPath: 'credential-api',
  tagTypes: [TagTypesEnum.Credential],
  baseQuery: portalQueryAuth('/credentials'),
  endpoints: (build) => ({
    loadCredentials: build.query<ResponseDataInterface<CredentialInterface[]>, string>({
      query: (applicationId: string) => `/?application=${applicationId}`,
      providesTags: [TagTypesEnum.Credential],
    }),
    loadLimitCredentials: build.query<
      ResponseDataInterface<CredentialInterface[]>,
      PaginationRequestInterface & { applicationId: string }
    >({
      query: ({ applicationId, ...pagination }: PaginationRequestInterface & { applicationId: string }) =>
        format({ pathname: '/', query: queryBuilder({ ...pagination, application: applicationId }) }),
    }),
    addCredential: build.mutation<ResponseDataInterface<CredentialInterface>, AddCredentialRequestInterface>({
      query: (credentials: AddCredentialRequestInterface) => ({
        url: '/',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: [TagTypesEnum.Credential],
    }),
    deleteCredential: build.mutation<ResponseDataInterface<CredentialInterface[]>, string>({
      query: (id: string) => ({
        url: id,
        method: 'DELETE',
      }),
      invalidatesTags: [TagTypesEnum.Credential],
    }),
  }),
});
